import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCurationsIndex = loadable(
  () =>
    import(
      /* webpackChunkName: "content/catalog/curationsindex" */
      '.'
    ),
);
